import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import type { IncidentCommandCenterFeatureData } from './IncidentCommandCenterFeatureData.types.tsx';
import { getProjectKeyFromContext } from './getProjectKeyFromContext.tsx';

const RESOURCE_TYPE_SERVICEDESK_INCIDENT_COMMAND_CENTER_FEATURE =
	'SERVICEDESK_INCIDENT_COMMAND_CENTER_FEATURE';

const ONE_DAY_IN_MILLIS = 60 * 60 * 1000 * 24;

export const incidentCommandCenterFeatureResource: RouteResource<IncidentCommandCenterFeatureData | null> =
	createResource<IncidentCommandCenterFeatureData | null>({
		type: RESOURCE_TYPE_SERVICEDESK_INCIDENT_COMMAND_CENTER_FEATURE,
		getKey: ({ match, query }) => getProjectKeyFromContext(match, query),
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-resource-servicedesk-incident-command-center-feature", jiraSpaEntry: "async-resource-servicedesk-incident-command-center-feature" */
				'./getDataIncidentCommandCenterFeatureResource.tsx'
			),
		maxAge: ONE_DAY_IN_MILLIS,
	});
